import React from 'react';
import BaseLayout from '../../components/BaseLayout/BaseLayout';

function PromoManagement() {

    return (
        <BaseLayout>
            <p>Promo Management</p>
        </BaseLayout>
    )
};

export default PromoManagement;